// extracted by mini-css-extract-plugin
module.exports = {"tabNav":"TasksAndChecklistsTabs_tabNav__3u9gA","active":"TasksAndChecklistsTabs_active__2x-EF"};